// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3KGr2","insightsList":"newBusinessInsightsMenu_insightsList__oyeRg","active":"newBusinessInsightsMenu_active__33uVh"};